import React, { Component } from 'react';

import Empresa from './empresaCom/empresa';
import FallBack from './fallBacksCom/fallBack';
import Conversa from './conversaCom/conversa';
import Interrac from './interacCom/interacciones';
import InterracHora from './interacHoraCom/interacHora';
import Intent from './intentsCom/intents';

class Estadisticas extends Component{

    render(){
        return(
            <div className='col s9 xl9 contenedorEstadisticas'>
                <div className='row'>
                    <Empresa />
                    <FallBack />
                    <Conversa />
                    <Interrac />
                    <Intent />
                    <InterracHora />
                </div>
            </div>
        );
    }
}


export default Estadisticas;